import React from "react";

export class WeightSemiBold extends React.Component<React.PropsWithChildren<{}>> {
    public render (): JSX.Element {
        return (
            <span className="weight-semi-bold">{this.props.children}</span>
        );
    }
}
